import { NavigationMockApi } from 'app/mock-api/common/navigation/api';
import { AutoContactMockApi } from 'app/mock-api/auto-contact/api';

export const mockApiServices = [
    NavigationMockApi,
    AutoContactMockApi,
];
